import { createFileRoute } from '@tanstack/react-router';

import { Inventory } from '@/pages';

export const Route = createFileRoute('/(app)/utils/inventory')({
  component: Inventory,
});
